import { ProFormDateRangePicker } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
export default withWrap(ProFormDateRangePicker);
